<template>
  <v-card>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      :disabled="loading"
      @submit.stop.prevent="submit"
    >
      <v-card-text>
        <h5 class="headline mb-4">
          Elac
        </h5>

        <v-text-field
          v-model="auth.email"
          label="Email"
          name="email"
          :rules="requiredRules"
          autofocus
          required
        />

        <v-text-field
          v-model="auth.password"
          label="Mot de passe"
          name="password"
          type="password"
          :rules="requiredRules"
          required
        />
      </v-card-text>

      <v-card-actions>
        <v-btn
          flat
          block
          color="primary"
          :disabled="!valid"
          :loading="loading"
          type="submit"
        >
          Se connecter
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'ElacLogin',

  data() {
    return {
      valid: false,
      loading: false,
      auth: {
        email: '',
        password: '',
      },
      requiredRules: [
        v => !!v || 'Champ obligatoire',
      ],
    };
  },

  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      this.$store.dispatch('auth/getToken', { auth: this.auth })
        .then(() => this.$store.dispatch('auth/loadUser'))
        .then(() => {
          // const user = this.$store.getters['auth/user'];
          // const tenants = user.roles.filter(r => r.tenant_id)
          // const teamTenants = tenants.filter(r => r.role === 'team')

          if (this.$router.currentRoute.query.p) {
            const query = {
              ...this.$router.currentRoute.query,
              p: undefined,
            };

            return this.$router.push({ path: this.$router.currentRoute.query.p, query });
          }

          return this.$router.push({ name: 'tenants' });
        })
        // .catch(err => this.$err(err))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
